import {Routes as jsRoutes} from "shared/js-routes"
import routeDefinitions from "nemoa/route-definitions.json"
import Routes from "@kaspernj/api-maker/build/routes.js"

const routes = new Routes({jsRoutes, routeDefinitions})

export default routes
